(function ($) {
	const $carousels = $('.wp-block-group.is-style-carousel, .js-slider');

	if (!$carousels.length) {
		return;
	}

	$carousels.each(function () {
		const $carousel = $(this);
		let slidesToShow = 1;
		let slidesToScroll = 1;

		let responsive = [];

		if ($carousel.hasClass('cards--single-row')) {
			slidesToShow = 6;
			slidesToScroll = 2;

			responsive = [
				{
					breakpoint: 1280,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					},
				},
				{
					breakpoint: 868,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			];
		}

		$carousel.slick({
			slidesToShow,
			slidesToScroll,
			autoplay: false,
			dots: true,
			arrows: true,
			infinite: false,
			autoplaySpeed: 5000,
			appendArrows: $carousel,
			appendDots: $carousel,
			prevArrow:
				'<button class="slick-prev"><span class="sr-only">prev</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"><circle cx="20" cy="19.996" r="20" fill="#165D34"/><path fill="#fff" d="M26.791 18.996h-11.17l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.58 6.6a.996.996 0 1 0 1.41-1.41l-4.87-4.89h11.17c.55 0 1-.45 1-1s-.45-1-1-1Z"/></svg></button>',
			nextArrow:
				'<button class="slick-next"><span class="sr-only">next</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"><circle cx="20" cy="19.996" r="20" fill="#165D34"/><path fill="#fff" d="M13.209 20.996h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41l4.87 4.89h-11.17c-.55 0-1 .45-1 1s.45 1 1 1Z"/></svg></button>',
			responsive,
		});
	});
	// trigger a resize event to force the carousel to recalculate the number of slides to show
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 100);
})(jQuery);
